// Active les vidéos selon le consentement donnée
(function(w) {
    w.CookieLawInfo_Accept_Callback = function () {
        console.debug(" CookieLawInfo_Accept_Callback")
        // La catégorie de cookie video est accéepté
        if (CLI.consent.video) {
            document.querySelectorAll(".video-iframe-placeholder").forEach( videoplaceholder => {
                var div = document.createElement('div');
                div.innerHTML =  videoplaceholder.getElementsByTagName("script")[0].innerHTML;
                videoplaceholder.innerHTML= div.textContent;                        
            })
            document.querySelectorAll(".no-consent-video").forEach( consent=> consent.remove());
        }
    }
})(window);